<template>
    <div class="progress-sticky">
        <div class="progress-sticky__container">
            <div class="progress">
                <div class="progress__list">
                    <div class="progress__item" @click="changeStage(stage)" :class="[{active : isNextStageActive(index)}, {disabled: stage.disabled}]" v-for="(stage, index) in stages" :key="stage.id">
                        <span class="progress__item-line"></span>
                        <span class="progress__item-name">{{ stage.name }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "IPProgressBar",
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            type: String,
            default: ''
        },
        stages: {
            type: Array,
            required: true,
            default: () => []
        },
    },
    computed: {
        value: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value)
            }
        },
        isNextStageActive() {
            return (index) => {
                if (this.value === 'finalStage') return true;

                const activeStage = this.stages.find(stage => stage.code === this.value);

                if (activeStage) {
                    return index < this.stages.indexOf(activeStage);
                } else {
                    return false;
                }
            }
        }
    },
    methods: {
        changeStage(stage) {
            if (!stage.disabled) this.value = stage.code;
        }
    }
}
</script>

<style scoped>

</style>